import { createHttpEndpoint } from '../../utils'

import type {
  GetInventoryOpportunities,
  GetInventoryOpportunitiesMetadata,
  GetPricingOpportunities,
  GetPricingOpportunitiesMetadata,
  GetPricingOpportunitiesMetrics,
} from './pricing-opportunities.types'

/**
 * Get the pricing opportunities for a given merchant
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-opportunities-api/definition#tag/Merchant-pricing-opportunities/operation/get-bm-merchants-pricing-opportunities}
 */
export const getPricingOpportunities =
  createHttpEndpoint<GetPricingOpportunities>({
    method: 'GET',
    operationId: 'get-bm-merchants-pricing-opportunities',
    path: '/bm/merchants/pricing-opportunities',
  })

/**
 * Get the metrics related to opportunities for a given merchant
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-opportunities-api/definition#tag/Merchant-opportunities-m[…]rchants-opportunities-metrics}
 */
export const getPricingOpportunitiesMetrics =
  createHttpEndpoint<GetPricingOpportunitiesMetrics>({
    method: 'GET',
    operationId: 'get-bm-merchants-opportunities-metrics',
    path: '/bm/merchants/pricing-opportunities/metrics',
  })

/**
 * Get the metadata related to pricing opportunities for a given merchant
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-opportunities-api/definition#tag/Merchant-pricing-opportunities-metadata/operation/get-bm-merchants-pricing-opportunities-metadata}
 */
export const getPricingOpportunitiesMetadata =
  createHttpEndpoint<GetPricingOpportunitiesMetadata>({
    method: 'GET',
    operationId: 'get-bm-merchants-pricing-opportunities',
    path: '/bm/merchants/pricing-opportunities/metadata',
  })

/**
 * Delete a pricing opportunity for a given merchant
 */
export const deletePricingOpportunity = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deletePricingOpportunity',
  path: '/bm/merchants/pricing-opportunities/:listingId/:market',
})

/**
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-experience-api/definition#/default/get_inventory_opportunities }
 */
export const getInventoryOpportunities =
  createHttpEndpoint<GetInventoryOpportunities>({
    method: 'GET',
    operationId: 'getInventoryOpportunities',
    path: '/api/seller-experience/opportunities/inventory',
  })

/**
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-experience-api/definition#/default/get_inventory_opp_metadata }
 */
export const getInventoryOpportunitiesMetadata =
  createHttpEndpoint<GetInventoryOpportunitiesMetadata>({
    method: 'GET',
    operationId: 'getInventoryOpportunitiesMetadata',
    path: '/api/seller-experience/opportunities/inventory/metadata',
  })
